import React from 'react';

import Gauge from 'details/components/gauge';
import LoadingMessage from 'details/components/loading_message';
import InterpretationBuilder from 'details/models/interpretation_builder';
import Tooltip from 'details/components/tooltip';

import { formatFloatingPoint, formatThousands } from 'shared/number_helper';

export default class SummaryTab extends React.Component {
    render() {
        return (
            <div className="SummaryTab">
                {this.summary}
                {this.props.publication.metricsLoaded ? (
                    this.content
                ) : (
                    <LoadingMessage text={I18n.t('summary_tab.loading')} />
                )}
            </div>
        );
    }

    get totalCitations() {
        return this.props.publication.totalCitations || 0;
    }

    get recentCitations() {
        return this.props.publication.recentCitations || 0;
    }

    get relativeCitationRatio() {
        return this.props.publication.relativeCitationRatio;
    }

    get fieldCitationRatio() {
        return this.props.publication.fieldCitationRatio;
    }

    get content() {
        let builder = new InterpretationBuilder(this.props.publication);

        return (
            <div className="SummaryTab-content">
                <div className="SummaryTab-content-text">
                    {builder.intro}
                    {builder.context}
                    <a className="jump-button" href={this.props.publication.dimensionsURI} target="_blank">
                        View more details in Dimensions
                    </a>
                </div>
                <div className="SummaryTab-content-gauges">
                    {this.citationsMetric}
                    {this.recentCitationsMetric}
                    {this.fieldCitationRatioMetric}
                    {this.relativeCitationRatioMetric}
                </div>
            </div>
        );
    }

    get summary() {
        return (
            <div className="SummaryTab-summary-wrapper">
                <div className="SummaryTab-summary">
                    <span className="count"></span>
                    <span className="content">
                        <p>{I18n.htmlSafe('summary_tab.data_from_dimensions')}</p>
                    </span>
                </div>
            </div>
        );
    }

    get citationsMetric() {
        return (
            <div className="SummaryTab-gauge-container total-citations">
                <div className="SummaryTab-gauge">
                    <Gauge value={this.scaledTotalCitations} circumference={0.75} />
                </div>
                <div className="metric-data">
                    <div className="count">{formatThousands(this.totalCitations)}</div>
                    <div className="label">{I18n.t('summary_tab.label.citations', { count: this.totalCitations })}</div>
                </div>
                <Tooltip
                    onClick={this.props.onToggleGlossary}
                    text={I18n.t('summary_tab.description.total_citations')}
                />
            </div>
        );
    }

    get recentCitationsMetric() {
        return (
            <div className="SummaryTab-gauge-container recent-citations">
                <div className="SummaryTab-gauge">
                    <Gauge value={this.scaledRecentCitations} circumference={0.75} transitionDelay={500} />
                </div>
                <div className="metric-data">
                    <div className="count">{formatThousands(this.recentCitations)}</div>
                    <div className="label">
                        {I18n.t('summary_tab.label.recent_citations', { count: this.recentCitations })}
                    </div>
                </div>
                <Tooltip
                    onClick={this.props.onToggleGlossary}
                    text={I18n.t('summary_tab.description.recent_citations')}
                />
            </div>
        );
    }

    get relativeCitationRatioMetric() {
        return (
            <div className="SummaryTab-gauge-container rcr">
                <div className="SummaryTab-gauge">
                    <Gauge value={this.scaledRelativeCitationRatio} circumference={0.75} transitionDelay={1500} />
                </div>
                <div className="metric-data">
                    <div className="count">{formatFloatingPoint(this.relativeCitationRatio)}</div>
                    <div className="label">{I18n.t('summary_tab.label.relative_citation_ratio')}</div>
                </div>
                <Tooltip onClick={this.props.onToggleGlossary} text={I18n.t('summary_tab.description.rcr')} />
            </div>
        );
    }

    get fieldCitationRatioMetric() {
        return (
            <div className="SummaryTab-gauge-container fcr">
                <div className="SummaryTab-gauge">
                    <Gauge value={this.scaledFieldCitationRatio} circumference={0.75} transitionDelay={1000} />
                </div>
                <div className="metric-data">
                    <div className="count">{formatFloatingPoint(this.fieldCitationRatio)}</div>
                    <div className="label">{I18n.t('summary_tab.label.field_citation_ratio')}</div>
                </div>
                <Tooltip onClick={this.props.onToggleGlossary} text={I18n.t('summary_tab.description.fcr')} />
            </div>
        );
    }

    get scaledTotalCitations() {
        return Math.min(10 * Math.pow(this.totalCitations, 0.4), 100);
    }

    get scaledRecentCitations() {
        if (!this.totalCitations || !this.recentCitations) {
            return 0;
        } else {
            return (this.recentCitations / this.totalCitations) * 100;
        }
    }

    get scaledRelativeCitationRatio() {
        return Math.min(100, 50 * Math.pow(this.relativeCitationRatio, 0.2));
    }

    get scaledFieldCitationRatio() {
        return Math.min(100, 50 * Math.pow(this.fieldCitationRatio, 0.2));
    }
}
